import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { useMediaQuery } from 'react-responsive';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Article } from '../../../../../hooks/api/article';
import { formatDate } from '../../../../../utils';

import styles from './index.module.scss';

interface CardSliderProps {
  data?: Article[];
  label?: string;
  icon?: React.ReactNode;
}
function NextArrow(props: any) {
  const { onClick } = props;

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <div className={styles.arrowNext} onClick={onClick} role="button" tabIndex={-1}>
      <RightOutlined style={{ width: 12, fontWeight: 700 }} />
    </div>
  );
}

function PrevArrow(props: any) {
  const { onClick } = props;

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <div className={styles.arrowPrev} onClick={onClick} role="button" tabIndex={-1}>
      <LeftOutlined style={{ width: 12 }} />
    </div>
  );
}

export default function CardSlider({ data, icon, label }: CardSliderProps): React.ReactNode {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(4);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 600) setSlidesToShow(1);
      else if (width < 900) setSlidesToShow(2);
      else if (width < 1200) setSlidesToShow(3);
      else if (width < 1900) setSlidesToShow(4);
      else if (width < 2560) setSlidesToShow(5);
      else setSlidesToShow(6);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const settings = {
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    infinite: true,
    speed: 700,
    cssEase: 'ease-in-out',
    slidesToShow,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setCurrentSlide(next),
  };

  const totalSlides = data?.length || 1;
  const maxSlideIndex = Math.max(totalSlides - slidesToShow, 1);
  const progressPercent = Math.min((currentSlide / maxSlideIndex) * 100, 100);

  return (
    <div className={styles.sliderWrapper}>
      <Slider {...settings}>
        {data?.map((item) => (
          <div
            key={item.id}
            role="button"
            tabIndex={-1}
            className={styles.cardWrapper}
            onClick={() => {
              navigate(`/article/${item.product.name}/${item.product.id}/${item.id}`);
            }}
          >
            <div className={styles.card}>
              <div className={styles.info}>
                <div className={styles.label}>
                  {typeof icon === 'string' && <img src={icon} alt="logo" />}
                  <span>{label}</span>
                </div>
                <span>{formatDate(item.createdAt)}</span>
              </div>
              <div className={styles.content}>
                <h4>{item.title}</h4>
                {/* <span>Category / Subcategory</span> */}
                {item.subCategory
                  ? (
                    <span className={styles.desc}>{`${item.category?.name}/${item.subCategory?.name}`}</span>
                  )
                  : (
                    <span className={styles.desc}>{`${item.category?.name}`}</span>
                  )}
              </div>
            </div>
          </div>
        ))}
      </Slider>
      <div className={styles.progressBarWrapper}>
        <div className={styles.progressBarContent}>
          <div className={styles.progressBar} style={{ width: `${progressPercent}%` }} />
        </div>
      </div>
    </div>
  );
}
